import React from 'react';
import {Row, Col} from 'react-flexbox-grid';
import './Home.scss';
import CentredContent from '../../components/CentredContent/CentredContent';
import Spacer from '../../components/Spacer/Spacer';
import SmartImageContainer from '../../components/SmartImageContainer/SmartImageContainer';
import Portrait from '../../components/Portrait/Portrait'


class Home extends React.Component {
    render() {
        return (
            <div className="home-page">
                <div className="atf">
                    <CentredContent>
                        <Row>
                            <Col xs={6} xsOffset={3} sm={3} smOffset={0}>
                                <div className="atf-logo">
                                    <img src="img/logo-ombra.png" alt="Emanuele Lena Sviluppo Web"></img>
                                </div>
                            </Col>
                            <Col xs={12} xsOffset={0} sm={8} smOffset={1}>
                                <div className="atf-title">
                                    <h1>Emanuele Lena</h1>
                                    <h2>
                                        Studente magistrale di informatica, sviluppatore software 
                                        e data scientist
                                    </h2>
                                </div>
                            </Col>
                        </Row>
                    </CentredContent>
                </div>

                <div className="projects-categories-bar">
                    <div className="project-category">
                        <SmartImageContainer src="img/progetti/uniud-sailing-lab.jpg" href="/progetti-vari" alt="altri progetti sviluppo software" title="Vedi Altri Progetti">
                            <h2 className="category-name">Progetti</h2>
                            {/* TODO: add subtitle */}
                        </SmartImageContainer>
                    </div>

                    <div className="project-category">
                        <SmartImageContainer src="img/progetti/sito-responsive.png" href="/portfolio" alt="portfolio siti web" title="Vedi Portfolio Siti Web" >
                            <h2 className="category-name">Siti Web</h2>
                            {/* TODO: add subtitle */}
                        </SmartImageContainer>
                    </div>
                </div>

                <Spacer height="50px"></Spacer>

                <div className="about-me-short">
                    <CentredContent>
                        <Row>
                            <Col xs={12} sm={4}>
                                <div className="about-me-short-picture">
                                    <Portrait src={"/img/profilo.jpg"} alt="Emanuele Lena Sviluppo Web" title="Questo sono io">
                                    </Portrait>
                                </div>
                            </Col>
                            <Col xs={12} sm={8}>
                                <div className="about-me-short-description">
                                    <div className="about-me-short-description-content">
                                        <h3>Qualcosa su di me</h3>
                                        <ul>
                                            <li>
                                                Laureato a pieni voti (<strong>110L</strong>) 
                                                in <a href="https://www.uniud.it/it/didattica/corsi/area-scientifica/scienze-matematiche-informatiche-multimediali-fisiche/laurea/internet-of-things-big-data-web/corso/internet-of-things-big-data-web"
                                                target='_blank'>Internet of Things, Big Data & Web</a> all'Università 
                                                degli Studi di Udine. 
                                            </li>
                                            <li>
                                                Attualmente, sono uno studente magistrale di Informatica, con specializzazione in <a 
                                                href="https://www.uniud.it/it/didattica/info-didattiche/piano-di-studio/laurea-magistrale-informatica/2021-2022#autotoc-item-autotoc-4"
                                                target="_blank">Progetto e sviluppo di sistemi software</a> e Data Science. 
                                            </li>
                                            <li>
                                                Da più di due anni, lavoro saltuariamente come libero professionista 
                                                (ho aiutato <a href="/portfolio">diverse aziende</a> ad affacciarsi al 
                                                web creado loro un sito e assistendo nella gestione). 
                                            </li>
                                        </ul>
                                        <Spacer height="20px"></Spacer>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <p>
                            Nel 2021 ho completato la mia laurea triennale (a pieni voti) con una 
                            tesi sperimentale sullo <a href="/progetti-vari/uniud-sailing-lab-neptune-2-0" 
                            title="Progettazione e sviluppo di Neptune 2.0">sviluppo di un software per 
                            l'assistenza alla navigazione a vela</a>. Al momento (fine 2023), sto portando a termine  
                            una Laurea Magistrale in Informatica, nella quale
                            ho approfondito tematiche come:
                        </p>
                        <ul>
                            <li>
                                la progettazione e lo sviluppo di software 
                                (paradigma Object-oriented, Design Pattern, Ing. del Software, testing automatizzato, 
                                sistemi distribuiti);
                            </li>
                            <li>
                                l'analisi dati, la data science, il machine learning e 
                                l'estrazione di informazioni da testi in linguaggio naturale (NLP);
                            </li>
                            <li>
                                i sistemi basati sui dati (e.g., Information Retrieval, motori di ricerca,
                            Sistemi di Raccomandazione);
                            </li>
                            <li>
                                la gestione di un progetto di sviluppo software (e.g., metodologie agili, SCRUM). 
                            </li>
                        </ul>
                        <p>
                            <a href="/progetti-vari">Qui</a> puoi trovare una lista di alcuni dei miei progetti più interessanti. 
                            Seguimi su <a href="https://github.com/emanuelena49">Github</a> per rimanere aggiornato su ciò che faccio. 
                        </p>                        
                    </CentredContent>
                </div>

                <Spacer height="50px"></Spacer>
            </div>
        );
    }
}

export default Home;